/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import StoryBanner from './StoryBanner';
import StoryCopy from './StoryCopy';

const useStyles = makeStyles((theme) => ({
    container: {
        margin: '10px 0px',
        paddingBottom: '10px',
    },
}));
const StoryBlock = ({
    data,
}) => {
    if (data?.blocks?.length === 0) { return null; }
    const classes = useStyles();
    return (
        <div className={classes.container} style={{ backgroundColor: data?.background_color }}>
            {
                data.blocks.map((block) => {
                    const blockKey = Object.keys(block);
                    const blockObj = block[blockKey];
                    switch (blockKey[0]) {
                        case 'images': return <StoryBanner data={blockObj} />;
                        case 'copy': return <StoryCopy data={blockObj} />;
                        default: return <></>;
                    }
                })
            }
        </div>
    );
};

StoryBlock.propTypes = {
    data: object.isRequired,
};
export default StoryBlock;
